import { isEqual } from "lodash";
import { useSetRecoilState } from "recoil";

import {
  courseHasUnsavedStationChangeAtom,
  ICourseMetadata,
} from "@ryde/shared";

export const useCourseStationsUpdateInfo = () => {
  const setCourseUnsavedStationChange = useSetRecoilState(
    courseHasUnsavedStationChangeAtom,
  );

  const setCourseHasStationChangeComputed = (
    prevMetadata: ICourseMetadata | undefined,
    nextMetadata: ICourseMetadata | undefined,
  ): void => {
    const stationsFrom = prevMetadata?.stationIds;
    const stationsTo = nextMetadata?.stationIds;
    const stationsInfoOrderFrom = prevMetadata?.stationsInfo?.map(
      station => station.id,
    );
    const stationsInfoOrderTo = nextMetadata?.stationsInfo?.map(
      station => station.id,
    );
    if (
      !isEqual(stationsFrom, stationsTo) ||
      !isEqual(stationsInfoOrderFrom, stationsInfoOrderTo)
    ) {
      setCourseUnsavedStationChange(true);
    }
  };

  return { setCourseHasStationChangeComputed };
};
